import { API_URL, API_VERSION } from '@constants';
import { useData } from '@hooks/useData';
import { paths } from '../../types/api';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';
import { useState } from 'react';

const ENDPOINT_URL = '/str-stores-workers/{uuid}';

const ENDPOINT_URL_WITH_VERSION = `${API_VERSION}${ENDPOINT_URL}` as const;
type url = typeof ENDPOINT_URL_WITH_VERSION;

export type GetAllStoreSchedulableWorkersSuccessResponse = paths[url]['get']['responses']['200']['content']['application/json'];
export type GetAllStoreSchedulableWorkersInput = paths[url]['get']['parameters']['path'];

/**
 * Requests endpoint to get all shipping countries.
 */
export const useGetAllStoreSchedulableWorkers = () => {
    const { getHeaders, getCommonParameters, handleCommonErrors } = useApiConfig();
    const { setAllStoreSchedulableWorkers } = useData();
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [lastResponseTime, setLastResponseTime] = useState<Date | null>(null);

    const request = async (props: GetAllStoreSchedulableWorkersInput) => {
        setLoading(true);
        setError(null);

        try {
            const inputParameters = new URLSearchParams({ ...getCommonParameters()}).toString();

            const response = await fetch(`${API_URL}${ENDPOINT_URL.replace('{uuid}', props.uuid || '')}?${inputParameters}`, {
                method: 'GET',
                headers: getHeaders(),
            });

            if (!response.ok) {
                let error;

                if (!response.ok) {
                    const json = await response.json();
                    const error = new Error(json.error || '') as ApiError;
                    error.statusCode = response.status;
                    throw error;
                }
                
                throw error;
            }

            const data: GetAllStoreSchedulableWorkersSuccessResponse = await response.json();

            setAllStoreSchedulableWorkers(data);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error: any) {
            handleCommonErrors(error);
            error.message && setError(error.message);
        } finally {
            setLoading(false);
            setLastResponseTime(new Date());
        }
    };

    return { request, loading, error, lastResponseTime };
};
